import { Consumption } from '../../schema/VehicleTileDataSchema';
import type { ParsedTechnicalData } from './TechnicalDataDls';

export const processDlsConsumption = (parsedTechnicalData: Partial<ParsedTechnicalData> | undefined): Consumption[] => {
  return parsedTechnicalData?.emissionData ?? [];
};
